var $ = require('../internals/export');

var parseInt = require('../internals/parse-int'); // `Number.parseInt` method
// https://tc39.github.io/ecma262/#sec-number.parseint


$({
  target: 'Number',
  stat: true,
  forced: Number.parseInt != parseInt
}, {
  parseInt: parseInt
});